import $ from 'jquery';
import Swiper from 'swiper/swiper-bundle.min';
import { MIN_DELAY } from '../variables/variables.js';



$( () => {
	if ( ! $( '.property' ).length ) {
		return;
	}

	// Слайдеры
	( () => {
		const $tabs      = $( '.property__front-tab' );
		const $contents  = $( '.property__front-content' );
		const $select    = $( '.property__front-images .select__input' );
		let   thumbnails = [];
		let   pictures   = [];

		// Создание слайдеров
		$contents.each( function( i ) {
			const $content = $( this );

			// Маленькие изображения
			thumbnails[i] = $content.find( '.property__front-thumbnails' )[0];

			if ( thumbnails[i] ) {
				thumbnails[i] = new Swiper( $content.find( '.property__front-thumbnails' )[0], {
					slidesPerView:       'auto',
					touchReleaseOnEdges: true,
				} );
			}

			const $current = $content.find( '.property__front-current' );

			function setCurrent( swiper ) {
				let current = swiper.activeIndex + 1;

				if ( current < 10 ) {
					current = '0' + current;
				}

				$current.text( current );
			}

			// Большие изображения
			pictures[i] = new Swiper( $content.find( '.property__front-pictures' )[0], {
				effect: 'fade',
				navigation: {
					prevEl: $content.find( '.swiper-button-prev' )[0],
					nextEl: $content.find( '.swiper-button-next' )[0],
				},
				thumbs: {
					swiper: thumbnails[i],
				},
				on: {
					init:              setCurrent,
					resize:            setCurrent,
					activeIndexChange: setCurrent,
				},
				touchReleaseOnEdges: true,
			} );
		} );

		// Переключение слайдеров при изменении селекта
		$select.on( 'change', () => {
			$tabs.eq( $select.val() ).trigger( 'click' );
		} );

		// Переключение слайдеров при клике на вкладки
		$tabs.on( 'click', function() {
			const $tab     = $( this );
			const INDEX    = $tab.index();
			const $content = $contents.eq( INDEX );

			if ( $tab.hasClass( 'property__front-tab_active' ) ) {
				return;
			}

			$tabs.removeClass( 'property__front-tab_active' );
			$tab.addClass( 'property__front-tab_active' );
			$contents.removeClass( 'property__front-content_active property__front-content_animate' );
			$content.addClass( 'property__front-content_active' );
			pictures[ INDEX ].update();

			if ( thumbnails[ INDEX ] ) {
				thumbnails[ INDEX ].update();
			}
			$select.val( INDEX ).trigger( 'change' );

			setTimeout( () => {
				$content.addClass( 'property__front-content_animate' );
			}, MIN_DELAY );
		} );
	} )();
} );
